module.exports = __webpack_public_path__ + "img/icon-generic-fan.71f94e85.svg";